import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StickyCallButton from "./components/StickyCallButton";
import Home from "./pages/Home";
import SnakeRescue from "./pages/SnakeRescue";
import Workshops from "./pages/Workshops";
import SafetyAudit from "./pages/SafetyAudit";
import Areas from "./pages/Areas";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/snake-rescue" element={<SnakeRescue />} />
          <Route path="/workshops" element={<Workshops />} />
          <Route path="/safety-audit" element={<SafetyAudit />} />
          <Route path="/areas" element={<Areas />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <StickyCallButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
